<form [formGroup]="form">
  <div formArrayName="items">
    <lps-checkbox-list
      *ngFor="let filter of filters; let i = index;"
      [formControlName]="i"
      [groupName]="filter.groupName"
      [options]="filter.options"
      (ngModelChange)="emit()"
      (onSelect)="sendEvent($event)"
      (onSelectAll)="sendEventWhenSelectingAll($event)"
    ></lps-checkbox-list>
  </div>
</form>

<ng-template #clearTemplate>
  <span
    class="search-filter__extra"
    [ngClass]="{
    'text-primary': this.value.length,
    'text-muted': !this.value.length
    }"
    (click)="cleanFilter($event)"
  >
    Limpar Filtros
  </span>
</ng-template>
